import { unaryRpc } from "@redotech/rpc/definition";
import * as z from "zod";

const shipToAddressInput = z.object({
  name: z.string().min(1),
  street1: z.string().min(1),
  street2: z.string().optional(),
  city: z.string().min(1),
  state: z.string().optional(),
  zip: z.string().min(1),
  country: z.string().length(2),
});

export const updateReturnsCenter = unaryRpc({
  name: "updateReturnsCenter" as const,
  input: z.object({
    returnsCenterId: z.string(),
    config: z.object({
      consolidationScheduleDays: z.number().int().positive().optional(),
      shipToAddress: shipToAddressInput.optional(),
      refulfillment: z.boolean().optional(),
      provider: z.string().optional(),
      externalHub: z
        .object({
          provider: z.string().min(1),
          locationId: z.string().optional(),
        })
        .nullable()
        .optional(),
    }),
  }),
  output: z.object({ ok: z.literal(true) }),
});
